/* import __COLOCATED_TEMPLATE__ from './salesforce-inline.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();